<template>
  <section v-on:click="bubbleOpen = false; openMenu = false; shareOpen = false"
    v-on:touchstart="bubbleOpen = false">
    <button class="backBtn" v-on:click="goBack"><span>Kembali</span></button>
    <div class="sound withBack">
      <div :class="{soundBtn: true, on: audioPlaying}"
        v-on:click="$emit('play')"></div>
      <div class="soundLabel">
        Sound
        <span v-if="audioPlaying">On</span>
        <span v-else>Off</span>
      </div>
    </div>
    <div class="menuCnt">
      <div class="menuToggle" v-on:click.stop="openMenu = !openMenu"></div>
      <div :class="{menu: true, open: openMenu}" v-on:click.stop="doNothing">
      <div class="menuItem left" v-on:click="openDownload">Download Brosur</div>
        <div class="menuItem right" v-on:click="openFaq">FAQ</div>
      </div>
    </div>
    <div class="lHeader">
      <div class="leafL"></div><div class="leafR"></div>
      <div class="rumputL"></div><div class="rumputL rumputL2"></div>
      <div class="rumputR"></div><div class="rumputR rumputR2"></div>
    </div>
    <div :class="{title: true, an: titleAn}"></div>
    <div class="umang"></div><div class="star1"></div><div class="star2"></div>
    <div class="recommender" v-on:click.stop="toggleBubble"
      v-on:touchstart.stop="doNothing">
      <div :class="{bubble: true, open: bubbleOpen, an: bubbleAn, cnt: bubbleCnt}"
        v-on:click.stop="doNothing">
        <div class="close" v-on:click.stop="bubbleOpen = false"></div>
        <div class="bubbleContent">
          <p>Halo {{name}}!</p>
          <p>Bingung pilih produk Nutrilite yang mana?</p>
          <p>Coba Nutrilite Recommender untuk mengetahui kebutuhan nutrisimu!</p>
          <a href="https://nutrilite.co.id/nutrilite-recommend" target="_blank"
            class="btn orange rounded">Coba Nutrilite Recommender</a>
        </div>
        <div class="arrow"></div><div class="arrow2"></div><div class="arrow3"></div>
      </div>
    </div>
    <div class="stages">
      <div class="stage1">
        <a class="stageItem collagen" target="_blank" href="https://www.amway.id/id/p/309293">
          <div class="nutrilite"></div>
          <div class="blink b1"></div><div class="blink b2"></div>
          <div class="blink b3"></div>
          <div class="stageTitle">Mixed<br />Collagen Drink</div>
        </a>
      </div>
      <div class="stage2">
        <a class="stageItem vitamin" target="_blank"
          href="https://www.amway.id/id/Categories/Nutrition/Food-Supplement-%26-Vitamin/c/foodsupplementvitamin">
          <div class="stageTitle">Food Supplement<br />&amp; Vitamin</div>
        </a>
        <a class="stageItem healthy" target="_blank"
          href="https://www.amway.id/id/Categories/Nutrition/Healthy-Beverages/c/healthybeverages">
          <div class="stageTitle">Healthy<br />Beverages</div>
        </a>
        <a class="stageItem weight" target="_blank"
          href="https://www.amway.id/id/Categories/Nutrition/Weight-Management/c/weightmanagement">
          <div class="stageTitle">Weight<br />Management</div>
        </a>
        <div class="tide"></div><div class="tideBg"></div>
      </div>
    </div>
    <div class="bolaPantai"></div><div class="payungB"></div>
    <div class="tide"></div><div class="tideBg"></div>
    <div class="copyright">
      <div class="shareFooter" :class="{open: shareOpen}"
        v-on:click.stop="shareOpen = !shareOpen"></div>
      <div class="socialLink" :class="{open: shareOpen}"
        v-on:click.stop="doNothing">
        <div class="sclLabel">Find Us On:</div>
        <a class="sclItem ig" target="_blank"
          href="https://www.instagram.com/nutrilite_id/"></a>
        <a class="sclItem fb" target="_blank"
          href="https://www.facebook.com/NutriliteID"></a>
        <a class="sclItem tw" target="_blank" :href="twUri"></a>
        <a class="sclItem wa" target="_blank" :href="waText"></a>
      </div>
      <div class="copy">
        &copy; Nutrilite Indonesia {{y}}
      </div>
    </div>
    <Main ref="main"/>
    <Faq ref="faq"/>
    <Download ref="download"/>
  </section>
</template>

<script>
import { mapState } from 'vuex';
import Main from '@/components/Main.vue';
import Faq from '@/components/Faq.vue';
import Download from '@/components/Download.vue';

export default {
  name: 'home',
  components: { Main, Faq, Download },
  data() {
    return {
      y: '',
      name: '',
      titleAn: false,
      bubbleOpen: true,
      bubbleAn: true,
      bubbleCnt: true,
      openMenu: false,
      shareOpen: false,
    };
  },
  methods: {
    doNothing() {},
    add2Calendar() {
      this.$refs.add2Calendar.open();
    },
    openDownload() {
      this.openMenu = false;
      this.$refs.download.open();
    },
    openFaq() {
      this.openMenu = false;
      this.$refs.faq.open();
    },
    goBack() {
      this.$router.push('/');
    },
    toggleBubble() {
      if (!this.bubbleOpen) {
        this.bubbleAn = false;
        this.bubbleOpen = true;
        this.bubbleCnt = false;
        setTimeout(() => {
          this.bubbleAn = true;
        });
        setTimeout(() => {
          this.bubbleCnt = true;
        }, 200);
      } else {
        this.bubbleOpen = false;
      }
    },
  },
  computed: {
    ...mapState(['audioPlaying']),
  },
  mounted() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    document.title = 'Nutrilite Site - Youthfuel Summer Fest – Amunisi Segar Untuk Kulitmu';
    const d = new Date();
    this.y = d.getFullYear();
    this.name = localStorage.getItem('name');
    const token = localStorage.getItem('token');
    if (!token) {
      this.$refs.main.open((name) => {
        this.name = name;
      });
    }
    setTimeout(() => {
      this.titleAn = true;
    });
  },
};
</script>

<style scoped lang="scss">
section{
  background-color: #ffc9ca;
  background-image: linear-gradient(#ffc9ca, #fdbbce);
  position: fixed;
  left: 0; top: 0; right: 0; bottom: 0;
  @media (max-height: 769px) {
    position: static;
  }
  @media (max-width: 680px) {
    position: static;
  }
}
.menuCnt{
  position: fixed;
  right: 0; top: 0;
  overflow: hidden;
  height: 100px; width: 400px;
  z-index: 997;
}
.logo{
  width: 160px; height: 200px;
  background-color: green;
  margin: 20px auto;
}
.stages{
  display: flex;
  justify-content: space-evenly;
  position: absolute;
  top: 170px; left: 50%;
  z-index: 9;
  transform: translateX(-50%);
  flex-wrap: wrap;
  width: 1400px;
  @media (max-width: 1400px) {
    width: auto;
    left: 60px; right: 60px;
    transform: none;
  }
  @media (max-width: 1400px) and (min-height: 800px) {
    top: 50%; transform: translateY(-50%);
  }
  @media (max-width: 1169px) {
    left: 20px; right: 20px;
  }
  @media (max-height: 769px) {
    position: relative;
    transform: none;
    left: auto; top: auto; right: auto;
  }
  @media (max-height: 769px) and (min-width: 681px) {
    padding: 200px 0 100px;
  }
  @media (max-width: 680px) {
    position: relative;
    transform: none;
    left: auto; top: auto; right: auto;
    display: block;
    transform: none;
    padding-top: 146px;
  }
  .stage1{
    width: 33.33333%;
    @media (max-width: 680px) {
      width: auto;
    }
    .stageItem{
      height: 550px;
      width: auto;
      margin: 0 10px;
      @media (max-width: 1400px) {
        height: 400px;
      }
      @media (max-height: 769px) {
        height: 350px;
      }
      @media (max-width: 680px) {
        height: 300px;
        margin: 0 10px 30px;
      }
    }
  }
  .stage2{
    width: 66.666666%;
    display: flex;
    flex-wrap: wrap;
    .tide, .tideBg{
      display: none;
      position: absolute;
    }
    @media (max-width: 680px) {
      width: auto;
      display: block;
      padding-bottom: 140px;
      overflow: hidden;
      position: relative;
      .tide, .tideBg{
        display: block;
      }
    }
    .stageItem{
      width: calc(50% - 20px);
      height: 260px;
      margin: 0 10px 30px;
      @media (max-width: 1400px) {
        height: 200px;
      }
      @media (max-height: 769px) {
        height: 174px;
      }
      @media (max-width: 680px) {
        width: auto; height: 300px;
        text-align: center;
      }
    }
  }
  .stageItem{
    box-sizing: border-box;
    border-radius: 10px;
    position: relative;
    font-family: CarlaSansBold;
    font-size: 20px;
    text-align: center;
    padding-top: 240px;
    transition: all .3s ease;
    cursor: pointer;
    display: block;
    text-decoration: none;
    color: #a8483d;
    @media (max-width: 1400px) {
      font-size: 16px;
      padding-top: 186px;
    }
    @media (max-width: 680px) {
      font-size: 18px;
      padding-top: 246px;
    }
    @media (max-height: 769px) and (min-width: 681px) {
      padding-top: 160px;
    }
    &:hover{
      transform: scale(1.1);
      @media (max-width: 680px) {
        transform: none;
      }
    }
    .stageTitle{
      position: relative;
      z-index: 3;
    }
    &:before{
      background-position: center;
      background-repeat: no-repeat;
      background-size: contain;
      position: absolute;
      left: 10px; right: 10px; top: 10px; bottom: 10px;
      content: "";
      z-index: 2;
      @media (max-width: 680px) {
        background-size: 220px auto;
      }
    }
    &:after{
      position: absolute;
      content: "";
      width: 260px; height: 100px;
      border-radius: 50%;
      left: 50%; bottom: 20px;
      transform: translateX(-50%);
      background-color: #f4acb8;
      z-index: 1;
      box-shadow: 4px 4px 14px rgba(0,0,0,.2);
      @media (max-width: 1400px) {
        width: 180px; height: 80px;
      }
      @media (max-width: 680px) {
        width: 200px; height: 80px;
        bottom: 56px;
      }
    }
    &.collagen{
      text-align: center;
      font-size: 30px;
      padding-top: 430px;
      @media (max-width: 1400px) {
        font-size: 24px;
        padding-top: 326px;
      }
      @media (max-height: 769px) {
        padding-top: 300px;
      }
      @media (max-width: 680px) {
        font-size: 18px;
        padding-top: 260px;
      }
      .blink{
        width: 100px; height: 100px;
        background-image: url(../assets/sparkle.png);
        background-size: contain;
        background-position: center;
        background-repeat: no-repeat;
        position: absolute;
        z-index: 4;
        left: 60px; top: 100px;
        @media (max-width: 1400px) {
          width: 80px; height: 80px;
        }
        @media (max-width: 680px) {
          left: 50%; transform: translateX(-50%);
          top: 80px; width: 70px; height: 70px;
          margin-left: -64px;
        }
        &.b2{
          width: 80px; height: 80px;
          left: auto; right: 60px; top: 200px;
          @media (max-width: 1400px) {
            width: 60px; height: 60px;
          }
          @media (max-width: 680px) {
            left: 50%; right: auto;
            margin-left: 74px;
            width: 50px; height: 50px;
            top: 140px;
          }
        }
        &.b3{
          width: 60px; height: 60px;
          top: 300px; left: 80px;
          @media (max-width: 1400px) {
            width: 40px; height: 40px;
            top: 240px;
          }
          @media (max-width: 680px) {
            left: 50%; top: 200px;
          }
        }
      }
      .nutrilite{
        width: 140px; height: 26px;
        background-color: #fff;
        border-radius: 50px;
        position: absolute;
        top: 80px; left: 50%;
        transform: translateX(-50%);
        background-image: url(../assets/nutrilite.png);
        background-size: 120px auto;
        background-position: center;
        background-repeat: no-repeat;
        @media (max-width: 1400px) {
          background-size: 100px auto;
          width: 120px; height: 20px;
          top: 50px;
        }
        @media (max-height: 769px) {
          top: 20px;
        }
        @media (max-width: 680px) {
          top: 24px;
        }
      }
      &:after{
        // background-color: #f4acb8;
        background-color: #fdcf9f;
        width: 360px; height: 120px;
        bottom: 80px;
        @media (max-width: 1400px) {
          width: 280px; height: 100px; bottom: 50px;
        }
        @media (max-width: 680px) {
          width: 200px; height: 80px;
          bottom: 46px;
        }
      }
      &:before{
        background-image: url(../assets/Kolagen.png);
        background-size: 300px auto;
        left: 50px;
        @media (max-width: 1400px) {
          background-size: 240px auto;
        }
        @media (max-width: 680px) {
          background-size: 200px auto;
        }
      }
    }
    &.vitamin{
      &:after{
        // background-color: #f4acb8;
      }
      &:before{
        background-image: url(../assets/suplemen-50.png);
      }
    }
    &.healthy{
      &:after{
        // background-color: #f4acb8;
        background-color: #f4d1d7;
      }
      &:before{
        background-image: url(../assets/healthy-50.png);
      }
      @media (max-width: 960px) {
        margin-top: 100px;
      }
      @media (max-width: 680px) {
        margin: 0;
      }
    }
    &.weight{
      &:after{
        // background-color: #f4acb8;
        background-color: #ffbc8d;
      }
      &:before{
        background-image: url(../assets/weight-50.png);
      }
      @media (max-width: 960px) {
        margin-top: -60px;
      }
      @media (max-width: 680px) {
        margin: 0;
      }
    }
  }
}
.payungB{
  width: 280px; height: 280px;
  position: fixed;
  left: 50%; bottom: -160px;
  background-image: url(../assets/umbrela-pink.png);
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  z-index: 7;
  display: none;
  @media (max-width: 680px) {
    display: block;
    width: 140px; height: 140px;
    top: 50%; left: -80px; margin-top: -40px;
  }
}
.bolaPantai{
  width: 120px; height: 120px;
  position: fixed;
  right: -60px; top: 50%;
  transform: translateY(-50%);
  margin-top: -30px;
  background-image: url(../assets/bola-pantai.png);
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  z-index: 4;
  @media (max-width: 680px) {
    width: 80px; height: 80px;
    top: 300px; right: -40px;
  }
}

.title{
  width: 440px; height: 260px;
  position: absolute;
  left: 50%; top: -260px;
  background-image: url(../assets/shopping-title.png);
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  margin-left: -220px;
  z-index: 91;
  transition: all .3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  &.an{
    top: -80px;
    @media (max-width: 960px) {
      top: -26px;
    }
    @media (max-width: 680px) {
      top: -70px;
    }
  }
  @media (max-width: 680px) {
    width: 280px; margin-left: -140px;
  }
}

.recommender{
  position: fixed;
  cursor: pointer;
  right: 60px; bottom: 30px;
  width: 120px; height: 120px;
  background-image: url(../assets/kepiting-orange-idle.png);
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  z-index: 99;
  @media (max-width: 1169px) {
    right: 30px; bottom: 20px;
  }
  @media (max-width: 960px) {
    width: 60px; height: 60px;
    background-size: 40px auto;
    background-color: #fdd5db;
    background-color: #ffecef;
    // background-color: #f8e051;
    border-radius: 30px 3px 30px 30px;
    box-shadow: 2px 2px 10px rgba(0,0,0,.4);
    right: 16px; bottom: 16px;
  }
  .bubble{
    position: absolute;
    right: 20px; bottom: 100%;
    margin-bottom: 20px;
    background-color: #ffe7ea;
    padding: 20px 24px;
    border-radius: 10px;
    width: 340px;
    box-shadow: 2px 2px 6px rgba(0,0,0,.3);
    display: none;
    &.open{
      display: block;
    }
    @media (max-width: 1400px) {
      width: 300px;
      font-size: 14px;
    }
    @media (max-width: 960px) {
      background-color: #ffecef;
      display: none;
      right: 0; margin-bottom: 10px;
      border-radius: 15px 15px 0 15px;
      width: 260px; padding: 20px;
      // font-weight: normal;
      // opacity: 0;
      transition: all .2s ease;
      width: 20px; height: 20px;
      overflow: hidden;
      .bubbleContent{
        opacity: 0;
        transition: all .1s ease;
      }
      &.cnt{
        .bubbleContent{
          opacity: 1;
        }
      }
      &.open{
        display: block;
      }
      &.an{
        opacity: 1;
        transform: none;
        width: 280px; height: 150px;
      }
    }
    .bubbleContent{
      position: relative;
      z-index: 7;
      p{
        margin: 0 0 16px;
        @media (max-width: 960px) {
          margin-bottom: 10px;
        }
      }
    }
    .arrow{
      position: absolute;
      border-left: transparent 16px solid;
      border-right: transparent 16px solid;
      border-top: #ffe7ea 20px solid;
      bottom: -20px; right: 30px;
      z-index: 2;
      @media (max-width: 960px) {
        display: none;
      }
    }
    .arrow2{
      position: absolute;
      border-left: transparent 20px solid;
      border-right: transparent 20px solid;
      border-top: #000 24px solid;
      bottom: -24px; right: 26px;
      z-index: 1;
      filter: blur(4px);
      opacity: .5;
      @media (max-width: 960px) {
        display: none;
      }
    }
    .arrow3{
      position: absolute;
      right: 20px; width: 60px; height: 20px; bottom: 0;
      background-color: #ffe7ea;
      z-index: 3;
      @media (max-width: 960px) {
        display: none;
      }
    }
    .btn{
      font-size: 14px;
      box-shadow: 2px 2px 4px rgba(0,0,0,.2);
      @media (max-width: 960px) {
        font-size: 12px;
        padding: 10px 14px 7px;
      }
    }
  }
}

.tideBg{
  background-image: url(../assets/tide-bg-fliped.png);
  background-size: cover;
  background-position: top center;
  background-repeat: no-repeat;
  position: fixed;
  left: -200px; right: 200px; bottom: -180px;
  height: 460px;
  transform: rotate(18deg);
  z-index: 1;
  @media (max-width: 1260px) {
    transform: rotate(20deg);
  }
  @media (max-width: 1024px) {
    right: 0; height: 400px;
  }
  @media (max-width: 680px) {
    height: 200px; bottom: 0;
    display: none;
  }
}
.tide{
  background-image: url(../assets/tide-fliped.png);
  background-size: cover;
  background-position: top center;
  background-repeat: no-repeat;
  position: fixed;
  left: -200px; right: 200px; bottom: -260px;
  height: 460px;
  transform: rotate(14deg);
  animation: tideAn 10s infinite ease;
  z-index: 3;
  @media (max-width: 1260px) {
    transform: rotate(18deg);
  }
  @media (max-width: 1024px) {
    right: 0; height: 400px;
  }
  @media (max-width: 680px) {
    height: 200px; bottom: 0;
    animation: tideAnSm 10s infinite ease;
    display: none;
  }
  @keyframes tideAn {
    0% {bottom: -240px;}
    40% {bottom: -300px;}
    60% {bottom: -300px;}
    100% {bottom: -240px;}
  }
  @keyframes tideAnSm {
    0% {bottom: -60px;}
    40% {bottom: -110px;}
    60% {bottom: -110px;}
    100% {bottom: -60px;}
  }
}
.star1{
  width: 74px; height: 74px;
  position: fixed;
  left: 260px; bottom: 180px;
  background-image: url(../assets/star-orange.png);
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  z-index: 1;
  @media (max-width: 680px) {
    width: 40px; height: 40px;
    left: 20px; bottom: 80px;
  }
}
.star2{
  width: 74px; height: 74px;
  position: fixed;
  right: 36%; bottom: 260px;
  background-image: url(../assets/star-pink.png);
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  z-index: 1;
  @media (max-width: 680px) {
    width: 60px; height: 60px;
    bottom: 200px; right: 40px;
  }
}
.umang{
  width: 74px; height: 74px;
  position: fixed;
  left: -74px; bottom: 120px;
  background-image: url(../assets/umang-grey.png);
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  animation: umangAn 65s infinite linear;
  z-index: 2;
  @media (max-width: 680px) {
    width: 40px; height: 40px;
    bottom: 80px;
  }
  @keyframes umangAn {
    from { left: -74px; }
    to { left: 110%; }
  }
}
.rumputL{
  width: 280px; height: 500px;
  position: fixed;
  left: 380px; top: -396px;
  background-image: url(../assets/rumput-l2.png);
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  animation: windAn 10s infinite ease;
  @media (max-width: 1100px) and (max-height: 1100px) {
    height: 400px; top: -320px; left: 240px;
  }
  @media (max-width: 680px) {
    height: 240px;
    top: -180px; left: 60px;
    display: none;
  }
  &.rumputL2{
    background-image: url(../assets/rumput-r2.png);
    left: 600px;
    top: -420px;
  }
}
.rumputR{
  width: 280px; height: 500px;
  position: fixed;
  right: 260px; top: -396px;
  background-image: url(../assets/rumput-r2.png);
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  animation: windAn 10s infinite ease;
  @media (max-width: 680px) {
    display: none;
  }
  &.rumputR2{
    background-image: url(../assets/rumput-l2.png);
    right: 460px;
    top: -420px;
    @media (max-width: 1600px) {
      display: none;
    }
  }
}
.lHeader{
  position: absolute;
  left: 0; right: 0; top: 0;
  overflow: hidden; height: 600px;
}
.leafL{
  width: 540px; height: 540px;
  position: fixed;
  left: -200px; top: -176px;
  background-image: url(../assets/leaf-l2.png);
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  animation: l1An 10s infinite ease;
  z-index: 8;

  width: 480px; height: 480px;
  left: -160px; top: -160px;
  @media (max-width: 1100px) and (max-height: 1100px) {
    width: 400px; height: 400px;
    left: -140px; top: -140px;
  }
  @media (max-width: 680px) {
    width: 240px; height: 240px;
    left: -80px; top: -80px;
  }
  @keyframes l1An {
    0% {transform: rotate(0deg);}
    10% {transform: rotate(0deg);}
    45% {transform: rotate(10deg);}
    55% {transform: rotate(10deg);}
    90% {transform: rotate(0deg);}
    100% {transform: rotate(0deg);}
  }
}
.leafR{
  width: 540px; height: 540px;
  position: fixed;
  right: -180px; top: -140px;
  background-image: url(../assets/leaf-r2.png);
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  animation: windAn 10s infinite ease;
  z-index: 8;

  width: 480px; height: 480px;
  right: -160px; top: -160px;
  @media (max-width: 1100px) and (max-height: 1100px) {
    width: 400px; height: 400px;
    right: -140px; top: -140px;
  }
  @media (max-width: 680px) {
    width: 240px; height: 240px;
    right: -80px; top: -80px;
  }
}
@keyframes windAn {
  0% {transform: rotate(0deg);}
  10% {transform: rotate(0deg);}
  45% {transform: rotate(8deg);}
  55% {transform: rotate(8deg);}
  90% {transform: rotate(0deg);}
  100% {transform: rotate(0deg);}
}
</style>
